<!-- Header -->
<div mat-dialog-title
	style="text-align: center; color: #A20000;"
	role="heading">
	WARNING
</div>

<!-- Body -->
<mat-dialog-content style="justify-content: center">
	<div style="margin-bottom: 20px; margin-top: 20px; text-align: center;">
		{{warningMessage}}
	</div>
	<div *ngIf="allowOverwrite"
		style="margin-bottom: 20px; text-align: center;">
		Do you want to overwrite this query?
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button *ngIf="allowOverwrite"
			image="Save.png"
			label="Overwrite"
			(clickEvent)="overwrite()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>